import { Platform, StreamType } from '@foundation-player/runtime';
import { PlayerType } from '../builder-config';

export function selectPlayerTypeByStreamTypesAndPlatform(streamTypes: StreamType[], platform: Platform): PlayerType {
  //check for chromecast first because no other player will work on chromecast
  if (platform === Platform.Chromecast) {
    return PlayerType.Chromecast;
  }

  if (streamTypes.length === 1 && streamTypes[0] === StreamType.Progressive) {
    return PlayerType.Native;
  }

  const DASH_JS_PLATFORMS: Platform[] = [
    Platform.SkyQ,
    Platform.MagentaG3,
    Platform.MagentaG4,
    Platform.MagentaG5,
    Platform.VodafoneGTV,
    Platform.VodafoneVTV,
  ];

  if (DASH_JS_PLATFORMS.includes(platform)) {
    return PlayerType.DashJs;
  }

  return PlayerType.Bitmovin;
}
